var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.screenWidth > 1000)?_c('div',{staticClass:"iframe"},[_c('iframe',{staticStyle:{"width":"650px","height":"100vh","margin":"auto","text-align":"center"},attrs:{"src":_vm.baseURL,"frameborder":"0"}})]):[_c('router-view'),_c('Footer')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }